import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcDiscrepancyType = DatabaseCode;

const quantity: RrcDiscrepancyType = {
  code: "QUANTITY",
  displayValue: {
    id: "common.entity.rrcdiscrepancytype.quantity",
    defaultMessage: "Quantity",
  },
};

const type: RrcDiscrepancyType = {
  code: "TYPE",
  displayValue: {
    id: "common.entity.rrcdiscrepancytype.type",
    defaultMessage: "Type",
  },
};

const other: RrcDiscrepancyType = {
  code: "OTHER",
  displayValue: {
    id: "common.entity.rrcdiscrepancytype.other",
    defaultMessage: "Other",
  },
};

export const rrcDiscrepancyType = {
  quantity,
  type,
  other,
};

export const rrcDiscrepancyTypes: RrcDiscrepancyType[] = Object.values(rrcDiscrepancyType);

export const toRrcDiscrepancyType = (code: string): RrcDiscrepancyType =>
  toDatabaseCode(code, rrcDiscrepancyTypes);

export const toRrcDiscrepancyTypeSafely = (
  code: string | undefined,
  defaultValue: RrcDiscrepancyType | undefined = undefined
): RrcDiscrepancyType | undefined => toDatabaseCodeSafely(code, rrcDiscrepancyTypes, defaultValue);
